import React, { createContext, useState, useContext, useEffect } from 'react';
import {
  getEndpointOverrides,
  setEndpointOverride as saveEndpointOverride,
  API_VERSIONS,
} from '../utils/apiVersionManager';

// Create the context
const ApiVersionContext = createContext();

/**
 * Provider component for API endpoint version management
 */
export function ApiVersionProvider({ children }) {
  const [overrides, setOverridesState] = useState({});

  // Initialize from localStorage on mount
  useEffect(() => {
    const storedOverrides = getEndpointOverrides();
    setOverridesState(storedOverrides);
  }, []);

  const updateEndpointOverride = (endpointId, version) => {
    saveEndpointOverride(endpointId, version);
    setOverridesState((prev) => {
      if (version === API_VERSIONS.DEFAULT) {
        const newState = { ...prev };
        delete newState[endpointId];
        return newState;
      }
      return {
        ...prev,
        [endpointId]: version,
      };
    });
  };

  const value = {
    overrides,
    updateEndpointOverride,
  };

  return (
    <ApiVersionContext.Provider value={value}>
      {children}
    </ApiVersionContext.Provider>
  );
}

/**
 * Hook to use the API version context
 */
export function useApiVersion() {
  const context = useContext(ApiVersionContext);
  if (!context) {
    throw new Error('useApiVersion must be used within an ApiVersionProvider');
  }
  return context;
}

export default ApiVersionContext;
